module.exports = __webpack_public_path__ + "30959c45b79640ec058b971801df2a5e.jpg";